export enum IStatus {
  READY = 'ready',
  DRAFT = 'draft',
}

export enum IStatusLabel {
  ready = 'Ready to use',
  draft = 'Draft',
}

export enum IExpiredStatus {
  expired = 'Expired',
}

export enum IActiveStatus {
  active = 'Active',
  inActive = 'Inactive',
}

export enum IOwner {
  OO = 'OO',
  CM = 'CM',
}
